import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ToastService } from './toast.service';
import type { ToastItem, ToastVariant } from './toast.types';

@Component({
  selector: 'tc-toast-outlet',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './toast-outlet.component.html',
  styleUrl: './toast-outlet.component.css',
})
export class ToastOutletComponent {
  readonly toast = inject(ToastService);

  readonly items = computed(() => this.toast.toasts());

  iconFor(variant: ToastVariant): string {
    switch (variant) {
      case 'success':
        return 'ri-checkbox-circle-line';
      case 'error':
        return 'ri-error-warning-line';
      case 'warning':
        return 'ri-alert-line';
      default:
        return 'ri-information-line';
    }
  }

  dismiss(item: ToastItem): void {
    this.toast.dismiss(item.id);
  }
}
